import React, { useId, useState } from 'react';
import { ControlIcon } from './CompactControls';

// Keep all panels mounted so changing groups never clears selections or dates.
export default function FilterGroups({ groups }) {
  const [active, setActive] = useState(groups[0].key);
  const id = useId();
  const selectWithKeyboard = (event, index) => {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % groups.length;
    if (event.key === 'ArrowLeft') next = (index + groups.length - 1) % groups.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = groups.length - 1;
    if (next === undefined) return;
    event.preventDefault();
    setActive(groups[next].key);
    document.getElementById(`${id}-tab-${groups[next].key}`)?.focus();
  };
  return <>
    <div className="filter-group-tabs" role="tablist" aria-label="Grupe filtera">
      {groups.map((group, index) => <button key={group.key} type="button" role="tab"
        id={`${id}-tab-${group.key}`} aria-controls={`${id}-panel-${group.key}`}
        aria-selected={active === group.key} tabIndex={active === group.key ? 0 : -1}
        onClick={() => setActive(group.key)} onKeyDown={event => selectWithKeyboard(event, index)}>
        <ControlIcon name={group.icon} /><span>{group.label}</span>
        <span className="filter-group-count" aria-label={`${group.count} odabrano`}>{group.count}</span>
      </button>)}
    </div>
    {groups.map(group => <section key={group.key} className="filter-group-panel"
      id={`${id}-panel-${group.key}`} role="tabpanel" aria-labelledby={`${id}-tab-${group.key}`}
      hidden={active !== group.key}>{group.content}</section>)}
  </>;
}
